/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { is404Error } from '@zcode/error-filters'
import * as Api from '@zcode/nr/es/shared/api'
import type { Dispatch } from 'redux'
import { logger } from '../../../logger'
import { setFetchedProfile, setProfile } from '../actions/index'

export const loadProfile = (keys: string) => async (dispatch: Dispatch) => {
  try {
    const profile = await Api.profile.get({
      keys,
    })
    dispatch(setProfile(profile))
  } catch (e) {
    if (!is404Error(e)) {
      logger.error('Failed to get profile', e)
    }
    dispatch(setFetchedProfile())
  }
}
